
import Vue, { PropType } from 'vue';
import { get } from 'lodash';
import IconButton from '@/common/icon-button/IconButton.vue';
import { Icon } from '@/common/icon/Icon.vue';
import Api from '@/core/api';
import { Unsubscriber } from '@/core/event-bus';
import { PlayerState } from '@/core/player-state';

export default Vue.extend({

    components: {
        IconButton
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        isLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    },

    data() {
        return {
            isPlaying: false,
            unsubscribers: [] as Unsubscriber[]
        };
    },

    computed: {
        icon(): Icon {
            return this.isPlaying ? Icon.pause : Icon.play;
        }
    },

    mounted() {
        const { unsubscriber, state } = this.api.onStateChange(
            (partial: Partial<PlayerState>) => {
                this.isPlaying = get(partial, 'isPlaying', this.isPlaying);
            }
        );

        this.isPlaying = get(state, 'isPlaying', this.isPlaying);

        this.unsubscribers.push(unsubscriber);
    },

    beforeDestroy() {
        for (const unsubscriber of this.unsubscribers) {
            if (typeof unsubscriber === 'function') {
                unsubscriber();
            }
        }
    },

    methods: {
        togglePlayPause() {
            if (this.isPlaying) {
                console.debug('[PlayPauseToggle] pause');
                this.api.pause();
            } else {
                this.api.play();
            }
        }
    }
});
